import { render, staticRenderFns } from "./ProductTwo.vue?vue&type=template&id=5081ffaa&"
import script from "./ProductTwo.vue?vue&type=script&lang=js&"
export * from "./ProductTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5081ffaa')) {
      api.createRecord('5081ffaa', component.options)
    } else {
      api.reload('5081ffaa', component.options)
    }
    module.hot.accept("./ProductTwo.vue?vue&type=template&id=5081ffaa&", function () {
      api.rerender('5081ffaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductTwo.vue"
export default component.exports